var resources = require('items-view-strings');
    var strings = resources['_JegAE2X4NM37XXw0C6nM2w'];
export { strings };
export default strings;
